import { render, staticRenderFns } from "./tree-list.vue?vue&type=template&id=7244c208&scoped=true"
import script from "./tree-list.vue?vue&type=script&lang=js"
export * from "./tree-list.vue?vue&type=script&lang=js"
import style0 from "./tree-list.vue?vue&type=style&index=0&id=7244c208&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7244c208",
  null
  
)

export default component.exports